export const dispatchChatEvent = (
  node: any,
  eventName: string,
  parameters?: any
) => node.dispatchEvent(createCustomEvent(eventName, parameters));

export const createCustomEvent = (eventName: string, parameters?: any) =>
  new CustomEvent(eventName, { detail: parameters });
